import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'collaborator',
  type: 'node--collaborator',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    nombre: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'collaborator_name',
    },
    apellidos: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'collaborator_surname',
    },
    empresa: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'empresa',
    },
    telefono: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'telefono',
    },
  },
  relationships: {},
};
export const CollaboratorService = createService(base, configuration, API_CONFIG.API);
export const CollaboratorModule = createModule(CollaboratorService, true);



// WEBPACK FOOTER //
// ./src/models/colaborador.js